import { LazyLoadImage } from "react-lazy-load-image-component";
import brokenImg from "../../../assets/png/brokenImg.png";
import { useState, memo } from "react";

const ImageCard = memo(function ImageCard(props) {
  const [errorImg, setErrorImg] = useState(false);

  return (
    <LazyLoadImage
      {...props}
      src={errorImg ? brokenImg : props?.src}
      onError={() => setErrorImg(true)}
    />
  );
});

export default ImageCard;
